import styled from "styled-components";
import theme from "../../../../styles/defaultTheme";

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 30px 100px;
    gap: 50px;
`;

export const Tittle = styled.div`
    font-size: ${theme.font.size24};
    color: ${(props) => props.theme.black};
    font-weight: bold;
`;

export const ButtonContainer = styled.div`

`;